export default
    {
        guardaSignos: "/enfermeria/guardaSignos",
        cargaSignos: "/enfermeria/cargaSignos",
        cargaPyt: "/enfermeria/cargaPyt",
        borraSomato: "/enfermeria/borraSomato",

        guardaEscalas:"/enfermeria/guardaEscalas",
        listEscalas:"/enfermeria/listEscalas",

        guardaMedicamento: '/enfermeria/guardaMedicamento',
        guardaMedicamentoRevision: '/enfermeria/guardaMedicamentoRevision',
        listMedicamentos: '/enfermeria/listMedicamentos',
        listMedicamentosRevision: '/enfermeria/listMedicamentosRevision',
        aplicaMed: '/enfermeria/aplicaMedicamento',

        guardaProcs: '/enfermeria/guardaProcs',
        listProcs: '/enfermeria/listProcs',

        listTipoInEg: '/catalogos/catalogoEnfermeriaInEg',
        guardaInEg: '/enfermeria/guardaInEg',
        listInEg: '/enfermeria/listInEg',

        listValInicial: '/enfermeria/listValInicial',
        guardaValInicial: '/enfermeria/guardaValInicial',

        guardaSoluciones:'/enfermeria/guardaSoluciones',
        listSoluciones:'/enfermeria/listSoluciones',

        recordValoracionInicial:'/enfermeria/recordValoracionInicial',
        recordMedicamento:'/enfermeria/recordMedicamento',
        recordEscalas:'/enfermeria/recordEscalas',
        recordSoluciones:'/enfermeria/recordSoluciones',
        recordNotas:'/enfermeria/recordNotas',

        listConciliaMedReportes:'/enfermeria/listConciliaMedReportes',
    }
